import React from 'react'
import configment from '@adc/configment'
import { UniquePlatformResource } from '@adc/sdk/types'

interface DownloadLinkProps {
  resource: UniquePlatformResource
  children?: React.ReactNode
  embeddedContext?: string
}

const DownloadLink: React.FC<DownloadLinkProps> = ({
  resource,
  children,
  embeddedContext = 'browser',
}) => {
  const downloadUrl = `${configment.get(
    'RESI_GRAPH_API_URL_EXTERNAL'
  )}/download/${resource.urn}`

  return (
    <a
      href={downloadUrl}
      rel='noopener noreferrer'
      target={embeddedContext === 'webview' ? '_self' : '_blank'}
      data-elm-id={`download_link_${resource.urn}`}
    >
      {children ?? 'Download'}
    </a>
  )
}

export default DownloadLink
